import Vue from "vue"
import _ from "lodash"

Vue.use({
  install: function(Vue) {
    Vue.prototype.$lodash = _
    Vue.prototype.$_ = _
  },
})
